import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { getApiHeader } from "./token";
export var lookup = function lookup(npi) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("api/physicians/npiLookup/".concat(npi), getApiHeader());
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var attestateMeAsUserManager = function attestateMeAsUserManager() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var requestConfig, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requestConfig = getApiHeader();
            requestConfig.headers = Object.assign(Object.assign({}, requestConfig.headers), {
              "Content-Length": 0,
              "Content-Type": "text/plain"
            });
            _context2.next = 4;
            return axios.put("api/physicians/attestate-me-as-user-manager", "", requestConfig);
          case 4:
            response = _context2.sent;
            if (!(response.status === 200)) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return");
          case 7:
            return _context2.abrupt("return", Promise.reject());
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var create = function create(physician) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.post("api/physicians", physician, getApiHeader());
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var getCurrent = function getCurrent() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return axios.get("api/physicians/current", getApiHeader());
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            if (!(_context4.t0.response.status >= window.appConfig.erroPageStartStatusCode)) {
              _context4.next = 11;
              break;
            }
            return _context4.abrupt("return", undefined);
          case 11:
            throw _context4.t0;
          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));
};
export var getInstitutions2 = function getInstitutions2(id, pageNumber, searchTerm, limit) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var response, data, finalResponse;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.get("api/physicians/".concat(id, "/institutions/search?page=").concat(pageNumber, "&search=").concat(searchTerm, "&limit=").concat(limit), getApiHeader());
          case 2:
            response = _context5.sent;
            // Map the different named properties
            data = response.data.data.map(function (notInstitution) {
              return {
                id: notInstitution.institutionId,
                name: notInstitution.institutionName,
                institutionCode: notInstitution.institutionCode,
                parentInstitutionCode: notInstitution.parentInstitutionCode,
                createdByUser: notInstitution.createdByUser
              };
            });
            finalResponse = {
              data: data,
              meta: response.data.meta
            };
            return _context5.abrupt("return", finalResponse);
          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};
export var getInstitutions = function getInstitutions(id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.get("api/physicians/".concat(id, "/institutions"), getApiHeader());
          case 2:
            response = _context6.sent;
            // Map the different named properties
            data = response.data.map(function (notInstitution) {
              return {
                id: notInstitution.institutionId,
                name: notInstitution.institutionName,
                institutionCode: notInstitution.institutionCode,
                parentInstitutionCode: notInstitution.parentInstitutionCode,
                createdByUser: notInstitution.createdByUser
              };
            });
            return _context6.abrupt("return", data);
          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};
export var setAddresses = function setAddresses(id, addresses) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return axios.put("api/physicians/".concat(id, "/addresses"), addresses, getApiHeader());
          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);
          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};
export var setPhones = function setPhones(id, phones) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.put("api/physicians/".concat(id, "/phones"), phones, getApiHeader());
          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};
// need email, name
export var getPhysicians = function getPhysicians(hospitalCode, customerStatus, pageNumber, searchTerm, pageSize) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var url, response, physicians;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = "api/PhysiciansV2/?hospitalCode=".concat(hospitalCode);
            if (customerStatus) {
              url += "&status=".concat(customerStatus, "&search=").concat(searchTerm, "&page=").concat(pageNumber, "&limit=").concat(pageSize);
            } else {
              url += "&status=&search=".concat(searchTerm, "&page=").concat(pageNumber, "&limit=").concat(pageSize);
            }
            _context9.next = 4;
            return axios.get(url, getApiHeader());
          case 4:
            response = _context9.sent;
            physicians = response.data;
            return _context9.abrupt("return", physicians);
          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};
export var getAdditionalRecipients = function getAdditionalRecipients(customerStatus, pageNumber, searchString, pageSize) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
    var url, response, physicians;
    return _regeneratorRuntime.wrap(function _callee0$(_context0) {
      while (1) {
        switch (_context0.prev = _context0.next) {
          case 0:
            url = "api/physiciansV2/additionalRecipient/?";
            if (customerStatus) {
              url += "&status=".concat(customerStatus, "&search=").concat(searchString, "&page=").concat(pageNumber, "&limit=").concat(pageSize);
            } else {
              url += "&status=&search=".concat(searchString, "&page=").concat(pageNumber, "&limit=").concat(pageSize);
            }
            _context0.next = 4;
            return axios.get(url, getApiHeader());
          case 4:
            response = _context0.sent;
            physicians = response.data;
            return _context0.abrupt("return", physicians);
          case 7:
          case "end":
            return _context0.stop();
        }
      }
    }, _callee0);
  }));
};
var getFavoriteTests = function getFavoriteTests(customerId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
    var response;
    return _regeneratorRuntime.wrap(function _callee1$(_context1) {
      while (1) {
        switch (_context1.prev = _context1.next) {
          case 0:
            _context1.next = 2;
            return axios.get("api/physicians/".concat(customerId, "/favorites/tests"), getApiHeader());
          case 2:
            response = _context1.sent;
            return _context1.abrupt("return", response.data);
          case 4:
          case "end":
            return _context1.stop();
        }
      }
    }, _callee1);
  }));
};
var getFavoriteICDCodes = function getFavoriteICDCodes(customerId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return axios.get("api/physicians/".concat(customerId, "/favorites/ICDCodes"), getApiHeader());
          case 2:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);
          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};
var getNotifications = function getNotifications(customerId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return axios.get("api/physicians/".concat(customerId, "/notifications"), getApiHeader());
          case 2:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);
          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};
var updateFavoriteTests = function updateFavoriteTests(customerId, updatedFavs) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return axios.put("api/physicians/".concat(customerId, "/favorites/tests"), updatedFavs, getApiHeader());
          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);
          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};
var updateFavoriteICDCodes = function updateFavoriteICDCodes(customerId, updatedFavs) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return axios.put("api/physicians/".concat(customerId, "/favorites/ICDCodes"), updatedFavs, getApiHeader());
          case 2:
            response = _context13.sent;
            return _context13.abrupt("return", response.data);
          case 4:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
};
var updateNotifications = function updateNotifications(customerId, updatedNotifications) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return axios.put("api/physicians/".concat(customerId, "/notifications"), updatedNotifications, getApiHeader());
          case 2:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);
          case 4:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
};
var addNoticeApproval = function addNoticeApproval(physicianId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return axios.post("api/physicians/".concat(physicianId, "/annual-notice-approval"), undefined, getApiHeader());
          case 2:
            response = _context15.sent;
            return _context15.abrupt("return", response.data);
          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
};
//CEP-81 - Add T&C approval record
export var addTnCApproval = function addTnCApproval(physician) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return axios.post("api/physicians/terms-consent", physician, getApiHeader());
          case 2:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);
          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
};
export default {
  create: create,
  getCurrent: getCurrent,
  getInstitutions: getInstitutions,
  getInstitutions2: getInstitutions2,
  setPhones: setPhones,
  setAddresses: setAddresses,
  lookup: lookup,
  getFavoriteTests: getFavoriteTests,
  getFavoriteICDCodes: getFavoriteICDCodes,
  getNotifications: getNotifications,
  updateFavoriteTests: updateFavoriteTests,
  updateFavoriteICDCodes: updateFavoriteICDCodes,
  updateNotifications: updateNotifications,
  addNoticeApproval: addNoticeApproval,
  addTnCApproval: addTnCApproval
};